module.exports = __webpack_public_path__ + "static/media/hero.e9d89bc7.jpeg";